module.exports = __webpack_public_path__ + "static/media/logo.8d92a45c.svg";